import { i18n } from "../../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { connect, ConnectedProps } from 'react-redux'
import { RootState } from '../../store'
import routes from '../../routes/routes'
import confirmService from '../../services/confirm.service'
import { ConfirmParams } from '../../components/Confirm/Confirm.state'
import { replacePage, replaceLimit, replaceSearch } from './ShipOrders.slice'
import { paginate, deleteShipOrder } from './ShipOrders.thunk'
import Button from '../../components/Button'
import Card from '../../components/Card'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import DataTable from '../../components/DataTable'
import HeadingRow from '../../components/HeadingRow'
import { TableHorizontalHeader } from '../../components/TableHorizontal'
import { ActionName } from '../../components/Actions'

interface ShipOrdersProps
  extends RouteComponentProps, ConnectedProps<typeof connector> {}

class ShipOrders extends Component<ShipOrdersProps> {
  headers: TableHorizontalHeader[] = [
    { heading: i18n('Ship code'), path: 'code' },
    { heading: i18n('Purchase order'), path: 'purchaseOrder' },
    { heading: i18n('Sales order'), path: 'salesOrder' },
    { heading: i18n('Customer'), path: 'customerSite.contact.customer.name' },
    { heading: i18n('Ship at'), path: 'shipAt', date: true },
    { heading: i18n('Quantity'), path: 'quantity' },
    { heading: i18n('Remaining quantity'), path: 'remainingQuantity' },
    { heading: i18n("Updated at"),
      path: 'updatedAt',
      date: true,
      tooltip: ['updatedUser.username']
    },
    { heading: i18n("Actions") }
  ]

  constructor (props: ShipOrdersProps) {
    super(props)
    this.handleLimitChange = this.handleLimitChange.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handlePaginate = this.handlePaginate.bind(this)
    this.handleCreateClick = this.handleCreateClick.bind(this)
    this.handleActionClick = this.handleActionClick.bind(this)
  }

  handleLimitChange (limit: string) {
    this.props.replaceLimit(Number(limit))
  }

  handleSearch (search: string) {
    this.props.replaceSearch(search)
  }

  handlePaginate (page: number) {
    this.props.replacePage(page)
  }

  handleCreateClick () {
    this.props.history.push(routes.shipOrderCreate)
  }

  handleActionClick (id: number, action: ActionName) {
    const { history } = this.props
    if (action === 'view') {
      const pathname = routes.shipOrder
      const state = { id }
      history.push({ pathname, state })
    } else if (action === 'scan') {
      const pathname = routes.shipOrderPallets
      const state = { id }
      history.push({ pathname, state })
    } else if (action === 'edit') {
      const pathname = routes.shipOrderEdit
      const state = { id }
      history.push({ pathname, state })
    } else if (action === 'delete') {
      const confirm: ConfirmParams = {
        id,
        type: 'warning',
        question: i18n('Are you sure to delete the ship order?'),
        confirmText: i18n('Yes'),
        cancelText: i18n('No'),
        onConfirm: () => this.props.deleteShipOrder(id)
      }
      confirmService.push(confirm)
    }
  }

  componentDidMount () {
    this.props.paginate()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="full">
          <Card>
            <HeadingRow
              heading={i18n("Ship Orders")}
              doc='ship-orders'>
              <Button
                text={i18n("Create")}
                onClick={this.handleCreateClick} />
            </HeadingRow>
            <DataTable
              headers={this.headers}
              data={this.props.data}
              total={this.props.total}
              from={this.props.from}
              to={this.props.to}
              currentPage={this.props.currentPage}
              lastPage={this.props.lastPage}
              limit={String(this.props.limit)}
              search={this.props.search}
              onLimtChange={this.handleLimitChange}
              onSearch={this.handleSearch}
              onPaginate={this.handlePaginate}
              onActionClick={this.handleActionClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

const mapStateToProps = (state: RootState) => {
  const { result, limit, search } = state.shipOrders
  const { data, total, from, to, currentPage, lastPage } = result
  return { data, total, from, to, currentPage, lastPage, limit, search }
}

const mapDispatchToProps = {
  paginate,
  deleteShipOrder,
  replacePage,
  replaceLimit,
  replaceSearch
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(withRouter(ShipOrders))
